import {observer} from 'mobx-react';
import CompletedIcon from 'img/green-checkmark@2X.png';
import IncompleteIcon from 'img/circle--jumbo@2x.png';

const SharedStatusIcon = observer(({shared}) => {
  return (
    shared ?
      <img className='mr1' style={{width: 10, height: 10}} src={CompletedIcon} alt='status'/> :
      <img className='mr1' style={{width: 10, height: 10}} src={IncompleteIcon} alt='status'/>
  );
});

const SharedWithReviewee = observer(({model, uiState}) => {
  const canManageSharing = uiState.canManageSharingFor(model);

  return (
    <div
      onClick={() => canManageSharing && uiState.openManageSharingModal(model)}
      style={{cursor: canManageSharing ? 'pointer' : 'default'}}
    >
      {model.reviews.map(review => {
        if (!review.isManagerReview) return null;

        return <div key={review.id} className='flex items-center'>
          <SharedStatusIcon shared={!!review.sharedAt}/>
          <span>{review.reviewer.name}</span>
        </div>;
      })}
    </div>
  );
});

export default SharedWithReviewee;
